$(document).ready(function(){
  if($('.product-brand-details').eq(0).html().trim() == ""){
    $('.product-brand-details').eq(0).closest('.product__accordion').remove();
  }
  if($('.product-tab-description').eq(0).html().trim() == ""){
    $('.product-tab-description').eq(0).closest('.product__accordion').remove();
  }

  // remove accordion if empty
  var accs = $('.product__accordion .accordion__content');
  for(var i = 0; i < accs.length; i++){
    if(accs.eq(i).html().trim() == ""){
      accs.eq(i).closest('.product__accordion').remove();
    }
  }
});

function isInViewport(ele) {
  var elementTop = ele.offsetTop;
  var elementBottom = elementTop + ele.offsetHeight / 2;
  var viewportTop = window.pageYOffset || document.documentElement.scrollTop;
  var viewportHalf = viewportTop + (window.innerHeight || document.documentElement.clientHeight) / 2;
  return elementBottom > viewportTop && elementTop < viewportHalf;
}

document.addEventListener('DOMContentLoaded', function(){
  const prodForm = document.querySelector('product-form.product-form')
  const prodMedia = document.querySelector('slider-component.thumbnail-slider')
  const prodMediaMain = document.querySelector('variant-radios')
  const prodMediaWrapper = document.querySelector('.product__media-wrapper')
  const stickyATC = () => {
                if (!isInViewport(prodForm)){
        prodForm.classList.add('sticky_atc')
      }
    // if (isInViewport(prodMedia)){
    //   prodForm.classList.remove('sticky_atc')
    // }
    // #blocked out by Sean to fix 1 image product case
        if (isInViewport(prodMediaWrapper)){
      prodForm.classList.remove('sticky_atc')
    }
    if (isInViewport(prodMediaMain)){
      prodForm.classList.remove('sticky_atc')
    } 

    
    
  }
  
  if (window.matchMedia("(max-width: 767.9px)").matches){

    stickyATC() 
  }
  
  window.addEventListener('scroll', function(){
    if (window.matchMedia("(max-width: 767.9px)").matches){
      stickyATC()
    }
  })
})